import { format as r } from "date-fns";
const a = (o, t) => r(o, t);
export {
  a as formatDate
};
//# sourceMappingURL=formatDate.js.map
